module.exports = __webpack_public_path__ + "img/tip.6ced1b73.jpg";